/**设置的弹框 */
<template>
  <el-popover
    placement="bottom"
    :visible="visible"
    popper-class="icon-popover-card"
    :hide-after="10"
    width="100"
  >
    <template #reference>
      <div @click="handleClickControlPopover">
        <i class="iconfont icon-a-wenxianduibishezhi_huaban1"></i>
        表格设置
      </div>
    </template>
    <template #default>
      <PopperEditHeightOrWidth
        :topic="'行高'"
        v-model:visible="lineHeightVisible"
        @update="handleUpdateLineHeight"
      >
        <template #content>
          <div
            :class="[
              'popover-item',
              ifClick == SETTING_TYPE.LINE_HEIGHT ? 'active' : '',
            ]"
            @click="handleClickItem(SETTING_TYPE.LINE_HEIGHT)"
          >
            行高
          </div>
        </template>
      </PopperEditHeightOrWidth>
      <PopperEditHeightOrWidth
        :topic="'列宽'"
        @update="handleUpdateColumnWidth"
        v-model:visible="colWidthVisible"
      >
        <template #content>
          <div
            :class="[
              'popover-item',
              ifClick == SETTING_TYPE.COLUMN_WIDTH ? 'active' : '',
            ]"
            @click="handleClickItem(SETTING_TYPE.COLUMN_WIDTH)"
          >
            列宽
          </div>
        </template>
      </PopperEditHeightOrWidth>
      <div
        :class="[
          'popover-item',
          ifClick == SETTING_TYPE.FIT_HEIGHT ? 'active' : '',
        ]"
        @click="handleClickItem(SETTING_TYPE.FIT_HEIGHT)"
      >
        自适应行高
      </div>
      <hr />
      <div
        :class="[
          'popover-item',
          ifClick == SETTING_TYPE.DEFAULT ? 'active' : '',
        ]"
        @click="handleClickItem(SETTING_TYPE.DEFAULT)"
      >
        系统默认
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import PopperEditHeightOrWidth from "./PopperEditHeightOrWidth.vue";
import {
  reactive,
  ref,
  watch,
  defineExpose,
  defineEmits,
  defineProps,
} from "vue";
import { bus } from "@/utils/mitt.js";
import { SETTING_TYPE, LINE_HEIGHT_TYPE } from "@/constant/compare.js";
import { SYSTEM_STYLE } from "@/constant/compare.js";

const emits = defineEmits(["close"]);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

//点击的是哪一个
const ifClick = ref("");
//卡片的显示隐藏
const lineHeightVisible = ref(false); //行高的显示隐藏
const colWidthVisible = ref(false); //列宽的显示隐藏

//表格的样式
const tableStyle = reactive({
  lineHeightType: "", //行高类型：1.自适应/2.非自适应
  columnWidth: SYSTEM_STYLE.WIDTH, //系统默认行宽
  lineHeight: SYSTEM_STYLE.HEIGHT, //系统默认行宽
  ifDefault: false, //是否系统默认
});
//设置的下拉框
const handleClickItem = (item) => {
  ifClick.value = item;
  switch (item) {
    case SETTING_TYPE.LINE_HEIGHT:
      //设置行高的popper
      lineHeightVisible.value = true;
      break;
    case SETTING_TYPE.COLUMN_WIDTH:
      //设置列宽的popper
      colWidthVisible.value = true;
      break;
    case SETTING_TYPE.FIT_HEIGHT:
      //自适应行高
      tableStyle.lineHeightType = LINE_HEIGHT_TYPE.FIT;
      tableStyle.lineHeight = "";
      tableStyle.ifDefault = false;
      bus.emit("update-table-style", tableStyle);
      emits("close");
      break;
    case SETTING_TYPE.DEFAULT:
      tableStyle.lineHeight = SYSTEM_STYLE.HEIGHT;
      tableStyle.columnWidth = SYSTEM_STYLE.WIDTH;
      tableStyle.lineHeightType = LINE_HEIGHT_TYPE.NOFIT;
      tableStyle.ifDefault = true;
      bus.emit("update-table-style", tableStyle);
      emits("close");
      break;
    default:
  }
};
// //点击打开设置
// const handleClickControlPopover = () => {
//   ifClick.value = "";
//   visible.settingCardVisible = !visible.settingCardVisible;
//   if (!visible.settingCardVisible) {

//   }
// };
//关闭内部卡片
const closeCard = () => {
  lineHeightVisible.value = false;
  colWidthVisible.value = false;
};
//自定义列宽
const handleUpdateColumnWidth = (value) => {
  tableStyle.lineHeightType = LINE_HEIGHT_TYPE.NOFIT;
  tableStyle.columnWidth = value;
  tableStyle.ifDefault = false;
  bus.emit("update-table-style", tableStyle);
  emits("close");
};
//自定义行高
const handleUpdateLineHeight = (value) => {
  tableStyle.lineHeightType = LINE_HEIGHT_TYPE.NOFIT;
  tableStyle.lineHeight = value;
  tableStyle.ifDefault = false;
  bus.emit("update-table-style", tableStyle);
  emits("close");
};

defineExpose({ closeCard });
</script>

<style lang="scss" scoped>
.iconfont {
  font-size: 14px;
}
.icon-popover-card {
  .popover-item {
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    font-size: 13px;
    padding: 0 8px;
  }
  .popover-item:hover {
    border-radius: 5px;
    background-color: #f5f5f5;
  }
  hr {
    margin: 3px 0;
    height: 1px;
    border: none;
    border-top: 1px solid #eaeaea;
  }
  .active {
    border-radius: 5px;
    background-color: #f5f5f5;
  }
}
.el-popover.el-popper.icon-popover-card {
  min-width: 100px !important;
  width: 100px !important;
}
</style>
